import { createFileRoute } from '@tanstack/react-router'

import PageInfrastructure from '@/pages/PageInfrastructure'

export const Route = createFileRoute('/settings/infrastructure')({
  component: PageInfrastructure
})
